module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic_1.31f59da6.woff";